// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import { media } from '../../helpers';
import Stars from './atoms/stars';
import type { Theme } from '../../types';

type Props = {
  type?: string,
  title: string,
  subTitle?: string,
};

const Ribbon = styled<any, Theme>('div')`
  align-items: center;
  background-image: ${props => props.theme.ribbon.backgroundGradient};
  color: ${props => props.theme.ribbon.color};
  display: none;
  filter: ${props => props.theme.ribbon.filter};
  flex-direction: column;
  font-size: 1.5rem;
  height: 4rem;
  justify-content: center;
  left: ${props => (props.type === 'carblock' ? '2rem' : '50%')};
  margin-left: ${props => (props.type === 'carblock' ? 'initial' : '-1.5rem')};
  padding: 0 1rem 1rem;
  position: absolute;
  text-transform: uppercase;
  top: ${props => (props.type === 'carblock' ? '-.5rem' : 'initial')};
  width: ${props => (props.type === 'carblock' ? '3rem' : '4.5rem')};
  z-index: 1;
  ${props => (props.type !== 'header' && css`
    display: flex;
  `)};
  ${props => (props.type === 'header' && css`
    ${media.sm(css`
      display: flex;
      left: initial;
      right: 1rem;
    `)}
    ${media.md(css`
      right: initial;
      left: 50%;
    `)}
  `)};
  ${props => (props.type === 'pdbInfo' && css`
    width: 2rem;
    font-size: 1.3rem;
    left: auto;
    height: 3rem;
    right: calc(${props.theme.column.padding} / 2);
    ${media.lg(css`
      width: 3rem;
      height: 4rem;
    `)}
  `)};

  &:after {
    border-left: 3.25rem solid transparent;
    border-right: 3.25rem solid transparent;
    border-top: 2rem solid ${props => props.theme.ribbon.backgroundColor};
    content: '';
    height: 0;
    left: 0;
    position: absolute;
    top: 5rem;
    width: 0;
    ${props => (props.type === 'carblock' && css`
      border-left: 2.5rem solid transparent;
      border-right: 2.5rem solid transparent;
      border-top: 1.5rem solid ${props.theme.ribbon.backgroundColor};
    `)}
    ${props => (props.type === 'pdbInfo' && css`
      border-left: 2rem solid transparent;
      border-right: 2rem solid transparent;
      border-top: 1.5rem solid ${props.theme.ribbon.backgroundColor};
      top: 4rem;
      ${media.lg(css`
        border-left: 2.5rem solid transparent;
        border-right: 2.5rem solid transparent;
        border-top: 1.5rem solid ${props.theme.ribbon.backgroundColor};
        top: 5rem;
      `)}
    `)};
  }
`;

const Title = styled<any, Theme>('span')`
  border-bottom: 1px solid ${props => props.theme.ribbon.color};
  font-size: ${props => (props.type === 'header' ? '1rem' : '0.8rem')};
  margin-top: 0.5rem;
  text-transform: uppercase;
  ${props => (props.type === 'pdbInfo' && css`
    font-size: 0.6rem;

    ${media.lg(css`
      font-size: 0.8rem;
    `)}
  `)};
`;

const Number = styled<any, Theme>('span')`
  font-size: 1.8rem;
  font-weight: bold;
  text-transform: uppercase;
  ${props => (props.type === 'pdbInfo' && css`
    font-size: 1rem;

    ${media.lg(css`
      font-size: 1.2rem;
    `)}
  `)};
`;

const RibbonComponent = ({ type, title, subTitle }: Props) => (
  <Ribbon type={type}>
    <Title type={type}>{title}</Title>
    {subTitle && <Number type={type}>{subTitle}</Number>}
    <Stars />
  </Ribbon>
);

RibbonComponent.defaultProps = {
  type: 'carblock',
  subTitle: '',
};

export default RibbonComponent;
